<template>
  <main v-if="isVisible" class="modal-wrapper">
    {{ isVisible }}
    <transition name="modal-anim">
      <section
        :class="{ 'modal-active': isVisible }"
        class="--fixed --flex --flex-col --full-height --full-width md:--justify-center --justify-end modal-cont --inset-x-0 --inset-y-0 --z-20"
        role="navigation"
        aria-label="Global Modal"
        style="--z-index: 99999"
      >
        <label @click="$emit('closeModal')" class="--bg-genpact-text-grey --fixed --full-height --full-width modal-backdrop --background-blur modal-cont --opacity-50 --inset-x-0 --inset-y-0" />

        <transition name="modal-content-anim">
          <section v-show="isVisible" class="--bg-white md:--w-1/2 md:--mx-8 md:--mx-auto --relative --w-auto">
            <label @click="$emit('closeModal')" class="--absolute fa-times fas --right-0 --top-0 --px-4 --py-3 --cursor-pointer --text-grey" aria-label="Close" />
            <slot>
              <h1 class="--my-8">modal window</h1>
            </slot>
          </section>
        </transition>
      </section>
    </transition>
  </main>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
};
</script>

<style lang="postcss">
.modal-open-toggle {
  inset-inline-start: -9999px;
}

.modal-content-cont {
  max-height: calc(100% - 85px);
}

.modal-content-anim-enter-active {
  animation: slide-in 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-content-anim-leave-active {
  animation: slide-in 0.3s cubic-bezier(0.4, 0, 0.2, 1) reverse;
}

@keyframes slide-in {
  0% {
    transform: translate3d(0, 100%, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>
